import { render } from "./GroupOfCommands.vue?vue&type=template&id=3355f7cc&scoped=true"
import script from "./GroupOfCommands.vue?vue&type=script&lang=js"
export * from "./GroupOfCommands.vue?vue&type=script&lang=js"

import "./GroupOfCommands.vue?vue&type=style&index=0&id=3355f7cc&scoped=true&lang=css"

import exportComponent from "../../../../biotron-complaint-20260813/WebMidiVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3355f7cc"]])

export default __exports__